import { Controller, useFormContext } from 'react-hook-form'
import { DEFAULT_SUPPLY_SOURCE, SupplySource } from '../../../../../types/medication.type'

export const SUPPLY_SOURCE_OPTIONS: { label: string; value: SupplySource }[] = [
  { label: 'Our pharmacy', value: 'in_house' },
  { label: 'Patient buys outside', value: 'outside' }
]

/** Short label for a supply source, for lists and print-outs. */
export const supplySourceLabel = (value: SupplySource | undefined | null) =>
  SUPPLY_SOURCE_OPTIONS.find(option => option.value === (value || DEFAULT_SUPPLY_SOURCE))?.label ?? 'Our pharmacy'

/**
 * "Supply" radio group bound to the order form's `supply_source` field: our pharmacy (default) or
 * the patient buys the medicine outside (pharmacy never sees that order).
 */
export const SupplySourceField = ({ name = 'supply_source' }: { name?: string }) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      defaultValue={DEFAULT_SUPPLY_SOURCE}
      name={name}
      render={({ field }) => (
        <fieldset className="m-0 min-w-0 border-0 p-0">
          <legend className="mb-1 p-0 text-sm font-medium">Supply</legend>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {SUPPLY_SOURCE_OPTIONS.map(option => (
              <label className="flex cursor-pointer items-center gap-2 text-sm" key={option.value}>
                <input
                  checked={(field.value || DEFAULT_SUPPLY_SOURCE) === option.value}
                  className="size-4 accent-[#5D352B]"
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={() => field.onChange(option.value)}
                  type="radio"
                  value={option.value}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        </fieldset>
      )}
    />
  )
}
